import { Link } from 'react-router-dom';
import { FovTypography } from 'components/typography';
import { getColor } from 'utils';
import styled, { css } from 'styled-components';
import constants from 'constants/index';

export const AppHeaderContainer = styled('header')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 2rem;
  min-height: ${constants.HEADER_HEIGHT / 16}rem;
  background-color: ${props => getColor(props, 'primary')};
  border-bottom: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
  justify-content: space-between;

  @media (max-width: 1024px) {
    padding: 0 1rem;
    gap: 0.5rem;
  }
`;

export const HeaderLogoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => (props.space || '10px')};
  height: 100%;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    gap: ${props => (props.space ? '12px' : '8px')};
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background: ${props => getColor(props, 'mediumGrey')};
  margin: 1rem;

  @media (max-width: 1024px) {
    margin: 0.5rem;
  }
`;

export const LogoContainer = styled('div')`
  display: flex;
  justify-content: flex-start;
  position: relative;
  align-items: center;
  width: 13.125rem;
  height: 100%;

  @media (max-width: 1024px) {
    width: auto;
    min-width: 0;
  }
`;

export const ThemeSwitchContainer = styled('div')`
  padding: 0 1.875rem;

  @media (max-width: 1024px) {
    padding: 0 0.5rem;
  }
`;

export const AppOptionsContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const MenuLink = styled(Link)`
  position: relative;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const BasicLink = styled('div')`
  position: relative;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const ClickableItem = styled('div')`
  cursor: pointer;
`;

export const Menu = styled(FovTypography)`
  display: flex;
  position: relative;
  align-items: center;
  font-weight: bold;
  letter-spacing: 0.035rem;
  color: ${props => {
    const themeColor = props.active ? 'accent' : 'onPrimary';
    return getColor(props, themeColor);
  }};

  &:hover {
    color: ${props => getColor(props, 'accent')};

    svg {
      color: ${props => getColor(props, 'accent')};
    }
  }
`;

export const ExploreButton = styled('div')`
  font-family: "Poppins-Medium";
  min-width: 110px;
  height: 30px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.035rem;
  cursor: pointer;

  border: 1px solid #383838;  /* Fix border syntax */
  border-radius: 30px;  /* Rounded corners */
  background-color: transparent; /* Clear background */
  color: ${props => {
    const themeColor = props.active ? 'accent' : 'onPrimary';
    return getColor(props, themeColor);
  }};

  &:hover {
    color: ${props => getColor(props, 'accent')};

    svg {
      color: ${props => getColor(props, 'accent')};
    }
  }
  margin-left: -50px;

  @media (max-width: 1024px) {
    margin-left: 0;
    min-width: 80px;
    padding: 0 0.5rem;
  }
`;

export const HeaderButton = styled('div')`
  font-family: "Poppins-Medium";
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.035rem;
  cursor: pointer;

  background-color: transparent; /* Clear background */
  color: ${props => {
    const themeColor = props.active ? 'accent' : 'onPrimary';
    return getColor(props, themeColor);
  }};

  &:hover {
    color: ${props => getColor(props, 'accent')};

    svg {
      color: ${props => getColor(props, 'accent')};
    }
  }
`;

export const CreateCaretDownContainer = styled('div')`
  transform: translateY(${props => props.active ? '0.25rem' : 0});
  transition: transform 0.2s ease;
`;

export const MenuItem = styled(FovTypography)`
  cursor: pointer;

  ${props => props.topLevel && css`font-weight: 600;`}

  &:hover {
    color: ${props => getColor(props, 'accent')};

    svg {
      color: ${props => getColor(props, 'accent')};
    }
  }
`;

export const NormalMenuItem = styled(MenuItem)`
  font-size: 0.9rem;
`;

export const MenuContainer = styled('div')`
  display: inline-flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  padding: 0 3rem;

  @media (max-width: 1024px) {
    padding: 0 0.5rem;
    min-width: 0;
    flex-shrink: 1;
  }
`;


export const FileNameContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-left: 15rem;

  @media (max-width: 1024px) {
    margin-left: 1rem;
    min-width: 0;
    overflow: hidden;
  }
`;

export const ProfileMenuContainer = styled(FovTypography)`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(4, auto);
  letter-spacing: 0.045rem;
  color: ${props => getColor(props, 'onPrimary')};
  flex-shrink: 0;
`;

export const Profile = styled('div')`
  position: relative;
`;

export const CreditsContainer = styled('div')`
  position: absolute;
  top: 1.55rem;
  right: 0;
`;

export const Credits = styled('button')`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font-family: inherit;
  font-size: 0.85rem;
  cursor: pointer;
`;

export const AddCreditsButton = styled('button')`
  padding: 0;
  border: none;
  background: none;
  color: ${props => getColor(props, 'accent')};
  font-family: inherit;
  font-size: 0.9rem;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${props => getColor(props, 'accentHover')};
  }
`;

export const InfoAndSupport = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  padding: 0.15rem;
  background-color: ${props => getColor(props, 'onPrimary')};
  color: ${props => getColor(props, 'primary')};
  font-weight: bold;
  cursor: ${props => props.noCursor ? 'default' : 'pointer'};
`;

export const Ellipses = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  position: absolute;
  top: 0.125rem;
`;

export const HelpIcon = styled('div')`
   display: flex;
  align-items: center;  /* Center vertically */
  justify-content: center; /* Center horizontally */
  font-size: 20px;
  font-weight: bold;
  width: 24px;  /* Adjust size as needed */
  height: 24px;
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
`;

export const Search = styled('div')`
  grid-area: search;
`;

export const Instructions =  styled('div')`
  margin-top: 1rem;
  & > p {
    margin-bottom: 0.5rem;
  }
  & ol {
    margin: 0;
    padding: 0;
    padding-left: 1.5rem;
    list-style-position: inside;
  }
  & ol li + li {
    margin-top: 0.25rem;
  }
`;

export const BetaBadge = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 11px;
  padding: 2px 8px;
  background-color: #e3f2fd;
  color: #1976d2;
  white-space: nowrap;

  @media (prefers-color-scheme: dark) {
    background-color: #1e3a5f;
    color: #64b5f6;
  }
`;

export const MenuItemContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
  padding: 4px 0;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }

  @media (prefers-color-scheme: dark) {
    &:hover {
      background-color: #2a2a2a;
    }
  }
`;